module.exports = __webpack_public_path__ + "static/media/wifi-icon.152ebba0.svg";